export default __webpack_public_path__ + "246e1321fad24b42fb6caa11e07c5f45.svg";